// jQuery(document).ready(function() {
//     function extractYouTubeId(url) {
//         if (!url) return null;

//         let short = url.match(/youtu\.be\/([^?]+)/);
//         if (short) return short[1];

//         let long = url.match(/v=([^&]+)/);
//         if (long) return long[1];

//         return null;
//     }
//     jQuery('.video-wrapper').on('click touchstart', function() {
//         console.log('Play icon clicked');
//         let wrapper = jQuery(this).closest('.video-wrapper');
//         let video = wrapper.find('.player').get(0);
//         if (video) {
//             // Check if the video is already playing
//             if (video.paused) {
//                 setTimeout(function() {
//                     video.muted = true; // Mute the video
//                     video.loop = true; // Loop the video
//                     video.play(); // Play the video

//                     // Hide the play icon and overlay
//                     wrapper.find('.play-button').hide();
//                     wrapper.find('.play-icon').hide();
//                     wrapper.find('.image-over-layer').hide();
//                 }, 500);
//             }
//         }
//         // 2. YOUTUBE VIDEO
//         const url = wrapper.data('video-url');
//         const videoId = extractYouTubeId(url);
    
//         if (videoId) {
//             const autoplayIframe = `
//                 <iframe 
//                     width="100%" 
//                     height="100%" 
//                     src="https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1"
//                     frameborder="0"
//                     allow="autoplay; encrypted-media"
//                     allowfullscreen>
//                 </iframe>
//             `;
    
//             // Remove overlay + play icon
//             wrapper.find('.image-over-layer, .play-button').hide();
    
//             // Insert iframe
//             wrapper.append(autoplayIframe);
//         }
//     });

//     // Add an event listener to handle pausing
//     jQuery('.player').on('pause', function() {
//         console.log('Video paused');
//         // Optionally, show the play button or overlay when paused
//         jQuery(this).closest('.video-wrapper').find('.play-button').show();
//         jQuery(this).closest('.video-wrapper').find('.image-over-layer').show();
//     });
// });

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.video-wrapper .play-button, .video-wrapper .play-icon').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrapper = this.closest('.video-wrapper');
      var video   = wrapper.querySelector('video.player');
      var ytId    = wrapper.getAttribute('data-youtube-id');
      var ytSlot  = wrapper.querySelector('.youtube-embed-slot');

      if (ytId && ytSlot) {
        // ---- YouTube video ----
        if (!ytSlot.querySelector('iframe')) {
          var iframe = document.createElement('iframe');
          iframe.className = 'player youtube-player';
          iframe.src = 'https://www.youtube.com/embed/' + ytId
                     + '?autoplay=1&mute=1&loop=1&playlist=' + ytId
                     + '&controls=1&rel=0&modestbranding=1&playsinline=1';
          iframe.setAttribute('frameborder', '0');
          iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
          iframe.setAttribute('allowfullscreen', '');
          ytSlot.appendChild(iframe);
        }
      } else if (video) {
        // ---- Uploaded video ----
        video.muted = true;
        video.loop  = true;
        video.play().catch(function (err) {
          console.error('Video play failed:', err);
        });
      }

      var overlay = wrapper.querySelector('.image-over-layer');
      if (overlay) overlay.style.display = 'none';
      this.style.display = 'none';
    });
  });
});

// main Header Js Start
 let lastScrollTop = 0;
    const mobileNav = document.querySelector('header.mobile_nav-fixed--true');

    function handleScroll() {
      if (!mobileNav) return; // Dawn theme has no Turbo mobile nav — early exit
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (window.innerWidth <= 768) {
        if (scrollTop < 200) {
          mobileNav.style.position = 'relative';
        } 
        else if (scrollTop > 200 && scrollTop > lastScrollTop) {
          mobileNav.style.position = 'relative';
        } 
        else if (scrollTop < lastScrollTop) {
          
          mobileNav.style.position = 'fixed';
        }
      }
      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }
let contactPage = document.querySelector('body.page-light-rolex-contact');
let messagePage = document.querySelector('body.page-light-rolex-send-message ');
if (!contactPage || !messagePage) {
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
}

// main Header Js End


if (jQuery('body').hasClass('product-custom-rolex')) {
  jQuery('.model-info_spec_heading').each(function(){
      var addClassHeding = jQuery(this).text().toLowerCase().replace(/\s/g, '');
      jQuery(this).addClass(addClassHeding);
  });
  
  jQuery( jQuery('.model-info_spec_heading.waterresistance').parent() ).insertAfter( jQuery('.model-info_spec_heading.modelcase').parent() );
  jQuery( jQuery('.model-info_spec_heading.dial').parent() ).insertAfter( jQuery('.model-info_spec_heading.bezel').parent() );
  jQuery( jQuery('.model-info_spec_heading.bracelet').parent() ).insertBefore( jQuery('.model-info_spec_heading.caliber').parent() );
  jQuery( jQuery('.model-info_spec_heading.movement').parent() ).insertAfter( jQuery('.model-info_spec_heading.bracelet').parent() );
}


// article page published-date shifting
const publishDate = document.querySelector('#publish-date');
if (publishDate) {
  let shiftedPublishedDate = publishDate.cloneNode(true);
  let targetElement = publishDate.parentElement.nextElementSibling.nextElementSibling.querySelector('.content-section')
  if(targetElement){
    targetElement.appendChild(shiftedPublishedDate);
  }
  publishDate.style.display = "none";
}

// rcpo-test-carousel

// rcpo-test-carousel


// rolex-custom-nav Start
document.querySelectorAll('.rolexNav-toggle').forEach(function(item) {
    item.addEventListener('click', function(e) {
        const target = '.' + e.currentTarget.getAttribute('data-target');
        if (e.currentTarget.classList.contains('is-open')) {
            e.currentTarget.classList.remove('is-open');
            document.querySelector(target).classList.remove('is-open');
        } else {
            document.querySelector(target).classList.add('is-open');
            e.currentTarget.classList.add('is-open');
        }
    });
});

if (document.querySelectorAll('a.rolex-upArrow').length > 0) {
    document.querySelectorAll('a.rolex-upArrow').forEach(function(item) {
        item.addEventListener('click', function(e) {
            e.preventDefault();
            const target = e.currentTarget.getAttribute('href');
            const offsetTop = document.querySelector(target).offsetTop;
            window.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
            });
        });
    });
}
// rolex-custom-nav End

// rolex custom carousel Start
if (document.querySelector('#explorecarousel-slider')) {
if (document.querySelectorAll('#explorecarousel-slider .exploreCarousel-item-custom').length > 4) {
    if (typeof Swiper !== 'undefined') {
        var flkty = new Swiper('#explorecarousel-slider .swiper', {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 10,
            breakpoints: {
                768: { slidesPerView: 3, slidesPerGroup: 3 },
                1024: { slidesPerView: 4, slidesPerGroup: 4 }
            },
            threshold: 10,
            navigation: {
                nextEl: '#explorecarousel-slider .swiper-button-next',
                prevEl: '#explorecarousel-slider .swiper-button-prev'
            },
            pagination: {
                el: '#explorecarousel-slider .swiper-pagination',
                clickable: true
            }
            // TODO swiper: original Flickity options without direct equivalents:
            //   selectedAttraction: 0.2, friction: 0.8 (inertia tuning)
            //   slidesToShow / slidesToScroll / responsive[] were unused Slick-style options
            //   (Flickity ignored them); responsive slide widths are handled by CSS
            //   (.swiper-wrapper > li { width: 25% / 33% / 50% })
        });
    }
}
}
// custom carousel End


// rolex custom collection carousel Start
if (document.querySelector('#collections-slider')) {
if (document.querySelectorAll('#collections-slider .exploreCarousel-item-collection-carousel').length > 4) {
    if (typeof Swiper !== 'undefined') {
        var flkty = new Swiper('#collections-slider .swiper', {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 10,
            breakpoints: {
                768: { slidesPerView: 3, slidesPerGroup: 3 },
                1024: { slidesPerView: 4, slidesPerGroup: 4 }
            },
            threshold: 10,
            navigation: {
                nextEl: '#collections-slider .swiper-button-next',
                prevEl: '#collections-slider .swiper-button-prev'
            },
            pagination: {
                el: '#collections-slider .swiper-pagination',
                clickable: true
            }
            // TODO swiper: selectedAttraction: 0.2, friction: 0.8 (Flickity inertia tuning)
        });
    }
}
}
// custom carousel End


// Banner slider
if (document.querySelector('#banner-slider')) {
    if (document.querySelectorAll('#banner-slider .exploreCarousel-item-banner').length > 1) {
        if (typeof Swiper !== 'undefined') {
            var flkty = new Swiper('#banner-slider .swiper', {
                slidesPerView: 1,
                threshold: 10,
                navigation: {
                    nextEl: '#banner-slider .swiper-button-next',
                    prevEl: '#banner-slider .swiper-button-prev'
                },
                pagination: {
                    el: '#banner-slider .swiper-pagination',
                    clickable: true
                }
                // TODO swiper: selectedAttraction: 0.2, friction: 0.8 (Flickity inertia tuning)
            });
        }
    }
}

// rolex certified pre-owned carousel Start
// if (document.querySelector('#rolex-related-product-carousel2')) {
//     if (document.querySelectorAll('#rolex-related-product-carousel2 .productCarousel-slide').length > 3) {
//         var flkty = new Flickity('#rolex-related-product-carousel2 .rolex-related', {
//             cellAlign: 'left',
//             contain: true,
//             wrapAround: false,
//             lazyLoad: 2,
//             prevNextButtons: true,
//             pageDots: true,
//             groupCells: true,
//             autoPlay: false, 
//             dragThreshold: 10,
//             selectedAttraction: 0.2, 
//             friction: 0.8, 
//             slidesToShow: 1, 
//             slidesToScroll: 1, 
//            responsive: [
//                 {
//                     breakpoint: 700,
//                     settings: {
//                         slidesToShow: 2,
//                         slidesToScroll: 1,
//                     }
//                 },
//                 {
//                     breakpoint: 550,
//                     settings: {
//                         slidesToShow: 2,
//                         slidesToScroll: 1,
//                     }
//                 }
//             ]
//         });
//     }
//   }
  // custom carousel End

// rolex custom carousel Start
if (document.querySelector('#explorecarousel-slider2')) {
if (document.querySelectorAll('#explorecarousel-slider2 .exploreCarousel-item-rcpo').length > 3) {
    if (typeof Swiper !== 'undefined') {
        var flkty = new Swiper('#explorecarousel-slider2 .swiper', {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 10,
            breakpoints: {
                768: { slidesPerView: 3, slidesPerGroup: 3 },
                1024: { slidesPerView: 4, slidesPerGroup: 4 }
            },
            loop: true,
            threshold: 10,
            navigation: {
                nextEl: '#explorecarousel-slider2 .swiper-button-next',
                prevEl: '#explorecarousel-slider2 .swiper-button-prev'
            },
            pagination: {
                el: '#explorecarousel-slider2 .swiper-pagination',
                clickable: true
            }
            // TODO swiper: selectedAttraction: 0.2, friction: 0.8 (Flickity inertia tuning)
        });
    }
}
}
// custom carousel End


// rolex custom carousel Start
if (document.querySelector('#new-watches-carousel')) {
if (document.querySelectorAll('#new-watches-carousel .exploreCarousel-item-new-watches').length > 4) {
    if (typeof Swiper !== 'undefined') {
        var flkty = new Swiper('#new-watches-carousel .swiper', {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 10,
            breakpoints: {
                768: { slidesPerView: 3, slidesPerGroup: 3 },
                1024: { slidesPerView: 4, slidesPerGroup: 4 }
            },
            threshold: 10,
            navigation: {
                nextEl: '#new-watches-carousel .swiper-button-next',
                prevEl: '#new-watches-carousel .swiper-button-prev'
            },
            pagination: {
                el: '#new-watches-carousel .swiper-pagination',
                clickable: true
            }
            // TODO swiper: selectedAttraction: 0.2, friction: 0.8 (Flickity inertia tuning)
        });
    }
}
}
// custom carousel End


// model-availability button JS Start

    const modelLinks = document.querySelectorAll('.model-primary_avail');

    modelLinks.forEach(link => {
        link.addEventListener('click',  scroolEffect );
    });

const rolexBackarrow = document.querySelectorAll('.rolex-backArrow');

    rolexBackarrow.forEach(link => {
        link.addEventListener('click',  scroolEffect );
    });

  function scroolEffect(event){
      event.preventDefault();
            
            const targetId = this.getAttribute('href').substring(1);

            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth' });
            }
  }

// model-availability button JS End


// World rolex or blog page code

jQuery(document).ready(function () {
        jQuery('.rolexblog a').on('click', function() {
      jQuery('body').addClass('rolexpostonly');
      jQuery('.otherblog').hide();
      jQuery('.eventblog').hide();
      jQuery('.exploreCarousel-list').slick('refresh');
     
    });
    jQuery(function(){
       var hash = jQuery(location).attr('hash');
       jQuery('body').addClass(hash);
    });
    if(window.location.href === "https://polachecks-sandbox-2.myshopify.com/pages/world-of-rolex/#rolex"){
       jQuery('body').addClass('rolexpostonly');
    }
    })



    jQuery(document).ready(function () {
        jQuery('.otherblog a').on('click', function() {
      jQuery('body').addClass('otherblogpostonly');
      jQuery('.rolexblog').hide();
      jQuery('.eventblog').hide();
      jQuery(window).scrollTop(0);
     
    });
    if(window.location.href === "https://polachecks-sandbox-2.myshopify.com/pages/world-of-rolex/#polachecksnews"){
       jQuery('body').addClass('otherblogpostonly');
    }   
    })




    jQuery(document).ready(function () {
        jQuery('.eventblog a').on('click', function() {
      jQuery('body').addClass('eventblogpostonly');
      jQuery('.rolexblog').hide();
      jQuery('.otherblog').hide();
      jQuery(window).scrollTop(0);
     
    });
    if(window.location.href === "https://polachecks-sandbox-2.myshopify.com/pages/world-of-rolex/#event"){
       jQuery('body').addClass('eventblogpostonly');
    }   
    })


jQuery('.tag a:contains("#rolex")').closest('.blog').addClass('rolexpost');
jQuery('.tag a:contains("#event")').closest('.blog').addClass('eventpost');
jQuery(".rolexpost").each(function(index){
    jQuery(this).addClass('tab'+(index+1));
  })




// Store Opening time

 // The day of the week (0 to 6). Sunday = 0 etc.
        const date = new Date();
        const today = date.getDay().toString();
        const daysList = jQuery('div.hoursItem');
        // updates the current hours of the store on the dropdown of the individual contact pages
        for (let index = 0; index < daysList.length; index++) {
            const day = daysList[index];
            if (today === jQuery(day).attr('data-day').toString()) {
                if (jQuery(day).find('strong span.hours').text().toLowerCase() === 'closed') {
                    jQuery('label.currentHours').addClass('closed');
                }
                const data = jQuery(day).find('.hours').text();
                jQuery('label.currentHours strong .hours').text(data);
            }
        }
        // dropdown toggle
        jQuery('button.hoursList-toggle').on('click', (e) => {
            if (jQuery('div.hoursList').hasClass('is-active')) {
                jQuery('div.hoursList').removeClass('is-active');
                jQuery(e.currentTarget).removeClass('is-active');
            } else {
                jQuery(e.currentTarget).addClass('is-active');
                jQuery('div.hoursList').addClass('is-active');
            }
        });


/* Products Load More button */

jQuery(document).ready(function() {
  
  var numberOfProductsToShow = 6;

  function showProducts(startIndex, endIndex) {
    jQuery('.custom-collection-list .product').each(function(index, product) {
      if (index >= startIndex && index < endIndex) {
        jQuery(product).css('display', 'block');
      } else {
        jQuery(product).css('display', 'none');
      }
    });

    var loadMore = jQuery('.product-load-more-btn');
    if (endIndex >= jQuery('.custom-collection-list .product').length) {
      loadMore.hide();
    } else {
      loadMore.show();
    }
  }

  showProducts(0, numberOfProductsToShow);

  jQuery('.product-load-more-btn').on('click', function() {
    var loadMore = jQuery(this);
    loadMore.html("Loading...");
    setTimeout(function() {
      numberOfProductsToShow += 6;
      showProducts(0, numberOfProductsToShow);
      loadMore.html("Load More");
    }, 1000);
  });
});


/* Contact page MAP and List tab code */

  // function goToByScroll(id) {
  //   document.documentElement.scrollTop = document.getElementById(id).offsetTop;
  //   document.body.scrollTop = document.getElementById(id).offsetTop;
  // }

  document.addEventListener("DOMContentLoaded", function() {
    // var storesListLink = document.getElementById('stores_list_link');
    // var storesMapLink = document.getElementById('stores_map_link');
    var mapView = document.getElementById('map_view');
    var listView = document.getElementById('list_view');
    var mapCanvas = document.getElementById('map_canvas');

    // storesListLink.addEventListener("click", function(e) {
    //   e.preventDefault();
    //   mapView.style.display = 'none';
    //   listView.style.display = 'flex';
    //   storesListLink.classList.add('active');
    //   storesMapLink.classList.remove('active');
    // });

    // storesMapLink.addEventListener("click", function(e) {
    //   e.preventDefault();
    //   mapView.style.display = 'block';
    //   listView.style.display = 'none';
    //   // storesListLink.classList.remove('active');
    //   storesMapLink.classList.add('active');
    // });

    zipcode = 89109;
    var t = window.outerWidth
  });


// Contact us and Store pages MAP Code

    function goToByScroll(id) {
        jQuery('html,body').animate({
            scrollTop: jQuery("#" + id).offset().top
        }, 'slow');
    }
                
    jQuery(document).ready(function() {
        // zipcode = 89109;
        var t = jQuery(window).outerWidth();

        jQuery('#map_canvas').css('height', '550px');

        initialize_map();

    });
                
    function initialize_map() {

    var locations = [['Rolex Boutique Topanga', '34.1907307', '-118.6039788', '0', '6600 CA-27 space 1084c,<br> Canoga Park, CA 91303, United States <br/>', '312-663-8500', 'monostore?store_id=8', 'https://g.page/polachecks-jewelers-calabasas?share', '/public/AMPFUSION/brands/skeleton/images/stock2_300x220.jpg']];
        var map = new google.maps.Map(document.getElementById('map_canvas'),{
            zoom: 13,
            center: new google.maps.LatLng(34.1907307,-118.6039788),
            mapTypeControlOptions: {
                mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'tehgrayz']
            }
        });
        var stylez = [{
            "featureType": "administrative",
            "elementType": "all",
            "stylers": [{
                "visibility": "off"
            }]
        }, {
            "featureType": "administrative",
            "elementType": "labels",
            "stylers": [{
                "visibility": "on"
            }]
        }, {
            "featureType": "administrative",
            "elementType": "labels.text.fill",
            "stylers": [{
                "color": "#6e6c6c"
            }]
        }, {
            "featureType": "administrative.country",
            "elementType": "geometry",
            "stylers": [{
                "weight": "0.85"
            }, {
                "lightness": "45"
            }, {
                "visibility": "on"
            }]
        }, {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [{
                "color": "#f2f2f2"
            }]
        }, {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [{
                "gamma": "1.09"
            }, {
                "lightness": "19"
            }]
        }, {
            "featureType": "landscape",
            "elementType": "labels",
            "stylers": [{
                "visibility": "on"
            }, {
                "lightness": "-21"
            }, {
                "weight": "0.01"
            }]
        }, {
            "featureType": "landscape.natural.landcover",
            "elementType": "geometry",
            "stylers": [{
                "saturation": "8"
            }, {
                "lightness": "8"
            }]
        }, {
            "featureType": "landscape.natural.landcover",
            "elementType": "geometry.fill",
            "stylers": [{
                "lightness": "6"
            }]
        }, {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [{
                "visibility": "off"
            }, {
                "saturation": "1"
            }, {
                "color": "#cfe1d3"
            }]
        }, {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [{
                "visibility": "off"
            }]
        }, {
            "featureType": "poi.attraction",
            "elementType": "labels",
            "stylers": [{
                "visibility": "off"
            }]
        }, {
            "featureType": "poi.medical",
            "elementType": "geometry.fill",
            "stylers": [{
                "visibility": "off"
            }]
        }, {
            "featureType": "poi.medical",
            "elementType": "geometry.stroke",
            "stylers": [{
                "visibility": "on"
            }]
        }, {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [{
                "visibility": "on"
            }, {
                "color": "#cfe1d3"
            }]
        }, {
            "featureType": "road",
            "elementType": "all",
            "stylers": [{
                "saturation": -100
            }, {
                "lightness": 45
            }]
        }, {
            "featureType": "road",
            "elementType": "geometry.fill",
            "stylers": [{
                "visibility": "on"
            }]
        }, {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [{
                "visibility": "on"
            }]
        }, {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [{
                "visibility": "on"
            }, {
                "color": "#dcdfe2"
            }]
        }, {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [{
                "visibility": "on"
            }]
        }, {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [{
                "visibility": "off"
            }]
        }, {
            "featureType": "road.highway",
            "elementType": "labels.icon",
            "stylers": [{
                "visibility": "off"
            }]
        }, {
            "featureType": "road.highway.controlled_access",
            "elementType": "geometry",
            "stylers": [{
                "visibility": "off"
            }]
        }, {
            "featureType": "road.highway.controlled_access",
            "elementType": "geometry.stroke",
            "stylers": [{
                "visibility": "on"
            }]
        }, {
            "featureType": "road.highway.controlled_access",
            "elementType": "labels",
            "stylers": [{
                "visibility": "off"
            }]
        }, {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [{
                "visibility": "on"
            }]
        }, {
            "featureType": "road.arterial",
            "elementType": "labels.icon",
            "stylers": [{
                "visibility": "off"
            }]
        }, {
            "featureType": "road.local",
            "elementType": "all",
            "stylers": [{
                "visibility": "on"
            }]
        }, {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [{
                "visibility": "on"
            }]
        }, {
            "featureType": "road.local",
            "elementType": "geometry.fill",
            "stylers": [{
                "visibility": "on"
            }]
        }, {
            "featureType": "road.local",
            "elementType": "labels",
            "stylers": [{
                "visibility": "on"
            }]
        }, {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [{
                "visibility": "off"
            }]
        }, {
            "featureType": "transit",
            "elementType": "geometry.fill",
            "stylers": [{
                "visibility": "on"
            }]
        }, {
            "featureType": "transit.line",
            "elementType": "geometry",
            "stylers": [{
                "visibility": "off"
            }]
        }, {
            "featureType": "transit.station",
            "elementType": "all",
            "stylers": [{
                "visibility": "on"
            }]
        }, {
            "featureType": "transit.station",
            "elementType": "geometry",
            "stylers": [{
                "gamma": "1.57"
            }, {
                "lightness": "-10"
            }]
        }, {
            "featureType": "transit.station",
            "elementType": "labels",
            "stylers": [{
                "weight": "0.01"
            }, {
                "visibility": "on"
            }, {
                "saturation": "-100"
            }, {
                "lightness": "-3"
            }]
        }, {
            "featureType": "transit.station",
            "elementType": "labels.icon",
            "stylers": [{
                "weight": "0.01"
            }]
        }, {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [{
                "color": "#c2d8e1"
            }]
        }, {
            "featureType": "water",
            "elementType": "labels.text",
            "stylers": [{
                "visibility": "on"
            }, {
                "color": "#b0bdc7"
            }]
        }];

        var mapType = new google.maps.StyledMapType(stylez,{
            name: "Locations"
        });
        map.mapTypes.set('tehgrayz', mapType);
        map.setMapTypeId('tehgrayz');

        var marker, i;

        for (i = 0; i < locations.length; i++) {
            marker = new google.maps.Marker({
                position: new google.maps.LatLng(locations[i][1],locations[i][2]),
                map: map,
                icon: 'https://s3.amazonaws.com/ISHOWIMAGES/Rolex/Rolex+Module/Contact+Us+Pages/retailer.png'
            });

            google.maps.event.addListener(marker, 'click', (function(marker, i) {
                return function() {

                    marker.setIcon('https://s3.amazonaws.com/ISHOWIMAGES/Rolex/Rolex+Module/Contact+Us+Pages/retailer_selected.png');

                    jQuery('#selected_store_details').css('visibility', 'visible');
                    jQuery('#selected_store_details').css('opacity', 1);
                    map.setZoom(18);
                    map.panTo(this.getPosition());

                    jQuery('#rolex_store_name').html(locations[i][0]);
                    jQuery('#rolex_store_address').html(locations[i][4]);
                    jQuery('#rolex_store_phone').html(locations[i][5]);
                    jQuery("#rlxContactCall").attr("href", "tel:" + locations[i][5]);
                    jQuery("#rolex_store_link").attr("href", locations[i][6]);
                    jQuery("#rolex_store_directions").attr("href", locations[i][7]);
                    jQuery("#store_image").css("background-image", "url(" + locations[i][8] + ")");

                    jQuery('#store_close_button').on('click', (function(e) {
                        e.preventDefault();
                        map.setZoom(9);
                   map.setCenter(new google.maps.LatLng(34.1533802,-118.647112));
                        jQuery('#selected_store_details').css('visibility', 'hidden');
                        jQuery('#selected_store_details').css('opacity', 0);

                        marker.setIcon('https://s3.amazonaws.com/ISHOWIMAGES/Rolex/Rolex+Module/Contact+Us+Pages/retailer.png');

                    }
                    ));
                }
            }
            )(marker, i));

        }
    }
                








